module.exports = "/images/vendor/flag-icon-css/flags/1x1/je.svg?ab89781e75ca3440dcb86aa8dbd620f3";